import React from 'react';
import { Field, Label, Switch as HeadlessSwitch } from '@headlessui/react';
import { cx } from './cx';

export interface SwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: React.ReactNode;
  disabled?: boolean;
  className?: string;
}

/** An on/off setting with its label after it, e.g. "Add another". */
export function Switch({ checked, onChange, label, disabled, className }: SwitchProps) {
  return (
    <Field disabled={disabled} className={cx('inline-flex items-center gap-2', className)}>
      <HeadlessSwitch
        checked={checked}
        onChange={onChange}
        className={cx(
          'group relative inline-flex h-5 w-9 flex-none cursor-pointer rounded-full bg-gray-300 transition-colors dark:bg-gray-600',
          'data-[checked]:bg-indigo-600 dark:data-[checked]:bg-indigo-600 data-[disabled]:cursor-not-allowed data-[disabled]:opacity-50',
          'focus:outline-none data-[focus]:ring-2 data-[focus]:ring-indigo-500 data-[focus]:ring-offset-2 dark:data-[focus]:ring-offset-gray-900',
        )}
      >
        <span
          aria-hidden="true"
          className="pointer-events-none mt-0.5 inline-block h-4 w-4 translate-x-0.5 rounded-full bg-white shadow transition-transform group-data-[checked]:translate-x-[18px] motion-reduce:transition-none"
        />
      </HeadlessSwitch>
      <Label className="cursor-pointer select-none text-sm text-gray-600 dark:text-gray-400">{label}</Label>
    </Field>
  );
}
